import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api/client';
import Button from '../../components/common/Button';
import Input from '../../components/common/Input';

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError('');

    try {
      await api.post('/api/auth/reset-password/request', { email });
      setSent(true);
    } catch {
      setError('エラーが発生しました。もう一度お試しください。');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 to-blue-800 p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">パスワードリセット</h1>
            <p className="text-gray-500 text-sm">
              登録済みのメールアドレスを入力してください
            </p>
          </div>

          {sent ? (
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">メールを送信しました</h2>
              <p className="text-gray-500 text-sm mb-6">
                パスワードリセット用のリンクを送信しました。<br />
                メールをご確認ください。
              </p>
              <Link to="/login" className="text-blue-600 hover:underline text-sm">
                ログイン画面に戻る
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              {error && (
                <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600">
                  {error}
                </div>
              )}

              <Input
                label="メールアドレス"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@example.com"
                required
              />

              <Button type="submit" className="w-full" loading={loading}>
                リセットリンクを送信
              </Button>

              <div className="text-center">
                <Link to="/login" className="text-blue-600 hover:underline text-sm">
                  ログイン画面に戻る
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
